import React, { useRef } from "react";
import PropTypes from "prop-types";
import useAnchorFocusOnMount from "./useAnchorFocusOnMount";

const Anchor = ({ anchor, title }) => {
  const anchorRef = useRef();
  useAnchorFocusOnMount(anchor, anchorRef);

  return (
    <a className="anchor" href={`#${anchor}`} id={anchor} ref={anchorRef}>
      {title}
    </a>
  );
};

Anchor.propTypes = {
  anchor: PropTypes.string.isRequired,
};

export default Anchor;
